import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../locales/tokens";

export type AssignTableHeadProps = {
  sortedBy: string;
};

export const AssignTableHead = ({ sortedBy }: AssignTableHeadProps) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" mb={1}>
      <Typography
        variant="body1"
        fontWeight={600}
        pl={15}
        width="50%"
        textAlign="left"
      >
        {t(tokens.common.access)}
      </Typography>
      <Typography
        variant="body1"
        fontWeight={600}
        px={1}
        width="18%"
        textAlign="center"
      >
        Дата призначення
      </Typography>
      {sortedBy === "User" && (
        <Typography
          variant="body1"
          fontWeight={600}
          px={1}
          width="18%"
          textAlign="center"
        >
          Призначено
        </Typography>
      )}
      <Typography
        variant="body1"
        marginLeft="auto"
        fontWeight={600}
        pr={9}
        width="14%"
        textAlign="right"
      >
        {t(tokens.common.actions)}
      </Typography>
    </Stack>
  );
};
